import {
  Button,
  ButtonGroup,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React, { useState } from 'react';

import { Form } from '../form/Form';

export const DeleteAccountConfirmationModal = ({
  isOpen,
  target,
  isSubmitting,
  onCancel,
  onSubmitForDeletion,
  children,
}: {
  isOpen: boolean;
  target: 'user account' | 'organization';
  isSubmitting: boolean;
  onSubmitForDeletion: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
}) => {
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>();
  const canDelete = inputValue === 'delete';
  return (
    <>
      <Modal isOpen={isOpen} onClose={onCancel} size="lg">
        <ModalOverlay />
        <Form
          className="bg-stripes-red"
          onSubmit={async (event) => {
            event.preventDefault();
            try {
              await onSubmitForDeletion();
            } catch (exception) {
              setErrorMessage((exception as Error).message);
            }
          }}
          noValidate
        >
          <ModalContent>
            <ModalHeader>
              <ModalTitle>
                Are you sure you want to delete your {target}?
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              {children}
              <p className="text-base font-semibold">
                This action cannot be undone. Type “delete” to confirm.
              </p>
              <div>
                <FormControl isInvalid={!!errorMessage}>
                  <FormLabel className="sr-only">Delete account</FormLabel>
                  <Input
                    isInvalid
                    isDisabled={isSubmitting}
                    onChange={(event) => {
                      setInputValue(event.target.value);
                    }}
                  />
                  <FormErrorMessage>{errorMessage}</FormErrorMessage>
                </FormControl>
              </div>
            </ModalBody>
            <ModalFooter>
              <ButtonGroup>
                <Button
                  variant="secondary"
                  isDisabled={isSubmitting}
                  onClick={onCancel}
                  type="button"
                >
                  Cancel
                </Button>
                <Button
                  variant="destructive"
                  isDisabled={!canDelete}
                  isLoading={isSubmitting}
                  type="submit"
                >
                  Yes, delete my {target}
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </ModalContent>
        </Form>
      </Modal>
    </>
  );
};
